import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, InjectionToken, isDevMode } from '@angular/core';

import { Observable, of, throwError, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ApiloaderService } from 'src/app/shared/loaders/apiloader/apiloader.service';
import { LoadSpinnerService } from 'src/app/shared/loaders/spinner/loadspinner.service';
import { environment } from 'src/environments/environment';

import { CachingStrategyService } from '../caching';
import { ErrorhanderService } from '../services/error-handler.service';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const DEFAULT_TIMEOUTCTX = new HttpContextToken<number>(() => 120000);

@Injectable({
  providedIn: 'root'
})
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(
    public loaderService: LoadSpinnerService,
    private apiloader: ApiloaderService,
    public errorService: ErrorhanderService,
  private strategy: CachingStrategyService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.strategy.isCacheable(req)) {
      return next.handle(req);
    }

    const timeoutValue = req.context.get(DEFAULT_TIMEOUTCTX) || 600000;

    if(req.headers.has('timeout')) {
      console.error('TIMEOUT FAIL for', req.url);
    }
    if(isDevMode()){
      console.info(`Timeout: ${timeoutValue}ms >>`, req.url);
    }

    return next.handle(req).pipe(
      timeout(timeoutValue),
      catchError((error) => this.handleTimeOut(error, req))
    );
  }

  private handleTimeOut(error: any,req: HttpRequest<any>): Observable<any> {
    if (error && (error instanceof TimeoutError)) {
      this.errorService.handleOffline(error?.message, 'Server not responding');
      console.error('TIMEOUT ERROR>> ', error);

        this.apiloader.WaitforOnline(req)
        .then((waited)=>{
          if(waited){

          }
        })
        .catch((err) => {
          return throwError(()=> err);
        });

      console.error('API/Server ERROR >> ', error?.message);

      return of(error);
    }

    if (error instanceof Error) {
      console.error('*** Not TIMEOUT >> IGNORING....', error);
    }

    return throwError(() => error);
  }
}
